import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseService } from '../../../shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { ModalService } from 'src/modules/base/services/modal.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { DialogConfig } from '../../dialog/dialog-config';

@Component({
    selector: 'app-document-viewer',
    templateUrl: './document-viewer.component.html',
    styleUrls: ['./document-viewer.component.scss'],
    standalone: false
})
export class DocumentViewerComponent implements OnInit {
  @Input() resourceName: any = 'file_document';
  @Input() newWay: boolean = false;
  @Input() documentId: any = undefined;
  @Input() imageData: any = undefined;
  @Input() multiDocumentId: any = undefined;
  showType: boolean = true;
  index: number = 0;
  show_TypeDD_arrow: boolean = true;
  @Input() config: any = {
    showTypeDropdown: true
  }
  showHistory: boolean = true;
  _currentData: any = {};
  sideListData: any = [];
  scrollData: { page_size: number; query_id: string; page_no: number, args: string } = { page_size: 10, query_id: 'GET_PAGE', page_no: 0, args: '' };
  imageSrc: any[] = [];
  slectedIndex: any;
  cardData: any;
  fileData: any[] = [];
  _currentPage: number = 0;
  listCount: any;
  document_type: string = 'emrImage';
  searchType: string = 'clinical';
  imageUrl: string = "";
  blobResp: any;
  sanitizerBlob: any;
  pdfDocument: any = {};
  textFile: any = {};
  decodedText: string;
  _flag: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private baseService: BaseService,
    private elementRef: ElementRef,
    private loaderService: LoaderService,
    private storageService: StorageService,
    private authenticationService: AuthenticationService,
    private sanitizer: DomSanitizer,
    private alerts: AlertsService,
    private modalService: ModalService,
    public rolePermissionService: RolePermissionService,
    private dialogConfig: DialogConfig
  ) { }

  async ngOnInit() {
    this.slectedIndex = 0;
    this['data'] = this.dialogConfig;
    // if (JSON.stringify(this['data']) != '{}' && this['data']){
    //   this.resourceName = this['data']
    // }
    if (this.route.snapshot.data.hasOwnProperty('showDD'))
      this.show_TypeDD_arrow = this.route.snapshot.data.showDD;
    if (this.route.snapshot.data.hasOwnProperty('searchType'))
      this.searchType = this.route.snapshot.data.searchType;
    if (this.documentId != undefined || this.multiDocumentId != undefined)
      this.showHistory = false;

    if(this.dialogConfig.data && this.dialogConfig.data.showHistory !=undefined && this.dialogConfig.data.showHistory==false)
    {
      this.showHistory = false;
    }
    if(this.dialogConfig.data && this.dialogConfig.data.show_TypeDD_arrow !=undefined && this.dialogConfig.data.show_TypeDD_arrow==false)
    {
      this.show_TypeDD_arrow = false;
    }
    // if (this.route.snapshot.queryParams.hasOwnProperty('key'))
    //   var args = "id:" + this.route.snapshot.queryParams.key;
    // this.baseService.get("GET_BY_ID", args, "patient", "patient-registration").subscribe(data => {
    //   if (data.resource)
    //     this.cardData = data.resource[0];
    //   // this.addResources("e_prescription");
    // })
    if (this.authenticationService.getUserType() == 'patient') {
      let data = { args: "id:" + this.authenticationService.getCurrentUser().user_id }
      await this.baseService.getData(data, "", "patient", "patient-registration", "GET_BY_ID").toPromise().then(res => {
        if (res)
          this.cardData = res.resource[0];
      })
    }
    else {
      this.storageService.getSessionStorageData("currentData", (data) => {
        if (data)
          this.cardData = data;
      });
    }

    if (this.documentId || this.multiDocumentId) {
    }else if(this['data']){
      this.getImageData(this['data'].data.documentId);
    } else {
      if (this.resourceName) {
        //TO Do in Case Of Input
        this._currentData.resource = this.resourceName;
        this._currentData.addAllowed = true;
        this._currentData.json = this._currentData.resource;
      } else if (this.route.snapshot.data.resource != undefined) {
        this.resourceName = this.route.snapshot.data.resource;
      }
      this.baseService.getResourceDef(this.resourceName, (resouceDef) => {
        if (resouceDef) {
          console.log("Resource Def ", resouceDef);
          this._currentData = resouceDef;
          this.valueChange(this.searchType)
          // this.getListData();
          //this._currentData.currentResourceName = resouceDef.display_name; // Not in use
        }
      });
    }
  }
  /**  
   * Here We are getting Data from the Api On the Basis Of Resource,Scroll Data Is passed
   * Srcoll Data contains @param page_size,@param query_id,@param page_no
   * 
   */

  valueChange(type) {
    console.log(this.cardData, 'cardData');
    this.searchType = type;
    this.sideListData = [];
    if (type == 'kyc') {
      this._currentData.list.APIresource.datasource = {
        "application": "facility-management",
        "resource": "uploadedfile_metadata",
        "queryId": "GET_BY_DOCUMENT_TYPE_AND_UHID",
        "args": "uhid:" + this.cardData.uhId + ",document_type:kyc"
      }
    } else if (type == 'clinical') {
      this._currentData.list.APIresource.datasource = {
        "application": "emr",
        "resource": "file_document",
        "queryId": "GET_DOCUMENT_BY_UHID",
        "args": "uhId:" + this.cardData.uhId + ",account_id:" + this.cardData.account_id + ""
      }
    }
    this.slectedIndex = 0;
    this.getListData()
  }
  getListData() {
    this.sideListData = [];
    this.listCount = 0;
    this.slectedIndex = 0;
    let resourceData = this._currentData.list.APIresource.datasource;
    // let resourceData = {
    //   queryId: 'GET_DOCUMENT_BY_UHID',
    //   args: ``,
    //   resource: this.resourceName,
    //   application: 'emr'
    // }
    this.scrollData.args = resourceData.args != undefined ? this.baseService.buildDyanamicStr(resourceData.args, { data: this.cardData }) : false;

    // this.scrollData.args = `uhId:${this.cardData.uhId},account_id:${this.cardData.account_id}`;
    this.scrollData.query_id = resourceData.queryId;
    // this.scrollData.page_no = this._currentPage;
    this.scrollData.page_no = this._currentPage;
    this.scrollData.page_size = 10;
    this.loaderService.showSpinner();
    this.baseService.getData(this.scrollData, "", resourceData.resource, resourceData.application).subscribe(res => {
      console.log("Data of the list", res);
      this.sideListData.push(...res.resource);
      this.listCount = res.count;
      this.imageSrc = [];
      this.fileData = [];
      this.blobResp = undefined;
      this.pdfDocument = undefined;
      // this.sideListData = this.sideListData.concat(res.resource);
      if (this.sideListData.length > 0) {
        console.log("this.sideListData[this.slectedIndex] ->", this.sideListData, this.slectedIndex, this.sideListData[this.slectedIndex])
        this.onClickSideList(this.sideListData[this.slectedIndex]);
      } else {
        this.loaderService.hideSpinner();
      }
    });
  }
  /**
   * on scrolling Function
   * event having Values (1-100)
   * Touch Bottom Output = 100
   */
  onScrollList(event) {
    // if (event === 100) {
    //   this.scrollData.page_no = this.scrollData.page_no + 1;
    //   this.getListData();
    // }
  }
  /**
   * When You Click On The Side List Function Will Fire
   * Passing the List Object On Click
   */
  onClickSideList(list, event?, index?) {
    console.log("List data", list);
    let target;
    this.slectedIndex = index;
    if (event && event.currentTarget) {
      target = event.currentTarget;
      let child = this.elementRef.nativeElement.getElementsByClassName('doc-view-list');
      for (let cl of child) {
        cl.classList.remove("doc-active-tab");
      }
      target.classList.add("doc-active-tab");
    }
    this.imageSrc = [];
    this.fileData = [];
    this.imageUrl = '';
    this.blobResp = undefined
    this.pdfDocument = undefined;
    if (list.hasOwnProperty('dms_resource')) {
      this.document_type = list.dms_resource;
    } else if (list.hasOwnProperty('document_type')) {
      this.document_type = list.document_type;
    } else {
      this.document_type = 'emrImage'
    }
    if (this.document_type == 'emrImage' || this.document_type == 'clinical')
      this.searchType = 'clinical';
    else
      this.searchType = this.document_type;
    // if (!this.newWay) {
    //   this.baseService.getfileData(list.imageId || list.documentId, this.document_type).then(
    //     res => {
    //       this.loaderService.hideSpinner();
    //       this.imageSrc[0] = res[0].imageSrc;
    //       this.fileData[0] = res[0].file;
    //     },
    //     err => {
    //       console.error("Error in getfileData");
    //     }
    //   )
    // }
    // else { // This is condition is for new design ways to display the view
    if (this._flag) {
      this.multiDocumentId = undefined;
    }
    if (this.multiDocumentId != undefined) {
      // for (let i = 0; i < this.multiDocumentId.length; i++) {
      this.documentId = this.multiDocumentId[0].documentId;
      // }
    } else {
      this.documentId = list.imageId != undefined ? list.imageId : list.documentId;
      if (list.documentIds != undefined) {
        this.documentId = list.documentIds[0].documentId
        this.multiDocumentId = list.documentIds;
        this._flag = true;
      }
    }
    this.imageUrl = "";
    setTimeout(() => {
      this.getImageData(this.documentId, list);
    });

    // }
  }

  getDocumentId(value) {
    if (value == 'left') {
      if (this.index > 0) {
        this.index--;
        this.documentId = this.multiDocumentId[this.index].documentId;
        this.pdfDocument = false;
        if (this.documentId) {
          if(this.documentId !=undefined && this.documentId !="" && this.documentId.includes("/")){
            this.baseService.getfileDataFromURL(this.documentId, this.document_type).then(res => {
              // this.imageSrc[0] = res[0].imageSrc;
              // this.fileData[0] = res[0].file;
              this.imageUrl = "";
              setTimeout(() => {
                this.getImageData(this.documentId, { folder_name: res[0].file.name });
              });
  
            }, err => {
              console.error("Error in getfileData");
            })
          }else{
            this.baseService.getfileData(this.documentId, this.document_type).then(res => {
              // this.imageSrc[0] = res[0].imageSrc;
              // this.fileData[0] = res[0].file;
              this.imageUrl = "";
              setTimeout(() => {
                this.getImageData(this.documentId, { folder_name: res[0].file.name });
              });
  
            }, err => {
              console.error("Error in getfileData");
            })
          }
          
        }
        // this.getImageData(this.documentId)
      }
    }
    if (value == 'right') {
      if (this.index < (this.multiDocumentId.length - 1)) {
        this.index++;
        this.documentId = this.multiDocumentId[this.index].documentId;
        this.pdfDocument = false;
        if (this.documentId) {
          if(this.documentId !=undefined && this.documentId !="" && this.documentId.includes("/")){
            this.baseService.getfileDataFromURL(this.documentId, this.document_type).then(res => {
              // this.imageSrc[0] = res[0].imageSrc;
              // this.fileData[0] = res[0].file;
              this.imageUrl = "";
              setTimeout(() => {
                this.getImageData(this.documentId, { folder_name: res[0].file.name });
              });
  
            }, err => {
              console.error("Error in getfileData");
            })
          }else{
          this.baseService.getfileData(this.documentId, this.document_type).then(res => {
            // this.imageSrc[0] = res[0].imageSrc;
            // this.fileData[0] = res[0].file;
            this.imageUrl = "";
            setTimeout(() => {
              this.getImageData(this.documentId, { folder_name: res[0].file.name });
            });

          }, err => {
            console.error("Error in getfileData");
          })
          }
        }
        // this.getImageData(this.documentId)
      }
    }
  }

  getImageData(documentId, list?: any) {
    if (this.imageData?.s3Document != null && this.imageData?.resource != null) {
      if (list == undefined) {
        list = {};
      }
      list.document_type = this.imageData.resource;
    }
    if(documentId && documentId.includes("/")){
      this.imageUrl =  '/dms/api/v1/' + (list != undefined && list.document_type ? list.document_type : 'emrImage') + '/image-response-entity?path=' + documentId;
    }else{
      this.imageUrl = this.baseService.getApiEndpoint("dms") + (list != undefined && list.document_type ? list.document_type : 'emrImage') + '/image-response-entity?args=id:' + documentId + '&application=dms';
    }
    this.loaderService.showSpinner();
    this.baseService.getFileByUrl(this.imageUrl, false).subscribe((res: any) => {
      if (res) {
        this.blobResp = res;
        this.sanitizerBlob = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(this.blobResp));
        if (this.blobResp.type == 'image/Png' || this.blobResp.type == 'image/gif' || this.blobResp.type == 'image/jpeg' || this.blobResp.type == 'image/png' || this.blobResp.type == 'image/jpg') {
          this.imageSrc[0] = this.imageUrl;
          this.fileData[0] = { name: (list != undefined && list.folder_name) ? list.folder_name : '' };
        } else if (this.blobResp && this.blobResp.type == 'application/pdf') {
          this.pdfDocument = {}
          this.pdfDocument['document_name'] = (list != undefined && list.folder_name) ? list.folder_name : '';
          this.pdfDocument['blob'] = this.blobResp;
        } else if (this.blobResp && this.blobResp.type == 'text/plain') {
          this.textFile.document_name = (list != undefined && list.folder_name) ? list.folder_name : '';

          this.baseService.getfileData(documentId, 'image-response-entity').then(data => {
            if (data && data[0] && data[0].imageSrc) {
              let encodedString = data[0].imageSrc.split(', ')
              encodedString.shift();
              this.decodedText = atob(encodedString);
            }
          })
        }
        // else if(this.blobResp && this.blobResp.type == 'application/dicom') {
        // }
        this.loaderService.hideSpinner();
      }
    }, (error: any) => {
      this.loaderService.hideSpinner();
      this.alerts.error('Error occurred')
    })
  }

  ngOnChanges() {
    if (this.imageData?.s3Document && this.imageData?.resource) {
      this.document_type = this.imageData.resource;
    }
    // create header using child_id
    this.pdfDocument = undefined;
    if (this.multiDocumentId != undefined) {
      this.documentId = this.multiDocumentId[0].documentId;
    }
    if (this.documentId && !this.documentId.includes("/"))
    {
      this.baseService.getfileData(this.documentId, this.document_type).then(res => {
        // this.imageSrc[0] = res[0].imageSrc;
        // this.fileData[0] = res[0].file;
        this.imageUrl = "";
        setTimeout(() => {
          this.getImageData(this.documentId, { folder_name: res[0].file.name });
        });
      }, err => {
        console.error("Error in getfileData");
      })
    }

    if (this.documentId && this.documentId.includes("/"))
    {
      this.baseService.getfileDataFromURL(this.documentId, this.document_type).then(res => {
        // this.imageSrc[0] = res[0].imageSrc;
        // this.fileData[0] = res[0].file;
        this.imageUrl = "";
        setTimeout(() => {
          this.getImageData(this.documentId, { folder_name: res[0].file.name });
        });
      }, err => {
        console.error("Error in getfileData");
      })
    } 

  }
  // }

  goPrev() {
    if (this._currentPage && this._currentPage != 0) {
      this._currentPage = this._currentPage - 1;
      return this.getListData();
    }
  }

  goNext() {
    this._currentPage = this._currentPage + 1;
    return this.getListData();
  }

  getClassToEnableDisableIcon() { // setting goNext icon disabled if datasource reaches maximum limit
    if (this.listCount > 0) {
      var lastPage = this.listCount / 10;
      if (lastPage > this._currentPage + 1) {
        return null;
      } else {
        return true;
      }
    }
    else
      return true;
  }

  deleteDocument(list) {
    this.modalService.confirm("DELETE", "Do you really want to delete this Document").subscribe(result => {
      if (result) {
        this.baseService.action({ id: list.id }, 'DELETE', 'emr', 'file_document').subscribe(res => {
          if (res.errCode != -1) {
            this.getListData();
            this.alerts.success("Deleted Successfully...")
          } else
            this.alerts.error("There is some error to delete document...")
        })
      }
    })
  }
}
